// Fetch wrappers for the verbal-authoring endpoints. Sibling to
// `recipesClient.ts`; kept separate so the dictation feature surface
// has one obvious import path.
//
// The server returns the same response shape from both endpoints, so a
// single response type covers both. Empty-transcript / empty-turn
// requests are filtered client-side before the fetch — the modal
// renders "Didn't catch anything" without touching the server (plan
// open-item §12.3).

import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  DictatedDraftExtractResponse,
  DictatedRecipeDraft,
} from "@/lib/manufacturing/types/recipeDictation";

export function extractRecipeFromTranscript(payload: { transcript: string }) {
  return manufacturingFetch<DictatedDraftExtractResponse>(
    "/api/mfg/recipes/extract-from-transcript",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function refineDictatedRecipeDraft(payload: {
  transcript: string;
  priorDraft: DictatedRecipeDraft;
  turn: string;
}) {
  return manufacturingFetch<DictatedDraftExtractResponse>(
    "/api/mfg/recipes/refine-draft",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function correctBomFromTranscript(payload: {
  priorDraft: DictatedRecipeDraft;
  transcript: string;
}) {
  return manufacturingFetch<DictatedDraftExtractResponse>(
    "/api/mfg/recipes/correct-bom",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}
